import { api } from './api';

export const getUser = async () => api.get('/user');

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const createUser = async ({ userRoleUuid, payload }) =>
    api.post('/users', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const fetchUserByRole = async ({ userRoleUuid, roleUuid }) =>
    api.post(
        '/users/fetch',
        { role_uuid: roleUuid },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

export const updateUserByRole = async ({ userRoleUuid, payload }) =>
    api.patch('/users', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const deleteUserByRole = async ({ userRoleUuid, roleUuid }) =>
    api.delete('/users', {
        headers: makeRoleHeaders(userRoleUuid),
        data: { role_uuid: roleUuid }
    });

export const resetSubordinateLoginPassword = async ({ userRoleUuid, roleUuid, password }) =>
    api.delete('/users/login', {
        headers: makeRoleHeaders(userRoleUuid),
        data: {
            role_uuid: roleUuid,
            password
        }
    });
